/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials } from "../../clients/individualPaymentLookupsController/getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials.ts";

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryKey =
  (
    courseRegistrationId: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams["courseRegistrationId"],
    params?: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams,
  ) =>
    [
      {
        url: "/api/v1/individualpayment/course-registrations/:courseRegistrationId/course-financials",
        params: { courseRegistrationId: courseRegistrationId },
      },
      ...(params ? [params] : []),
    ] as const;

export type GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryKey
  >;

export function getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryOptions(
  courseRegistrationId: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams["courseRegistrationId"],
  params?: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryKey(
      courseRegistrationId,
      params,
    );
  return queryOptions<
    GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401
      | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500
    >,
    GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials(
        courseRegistrationId,
        params,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Respeita vigência (StartDate/EndDate), restrição por turma e empresa (curso ou CourseCompanies). A empresa do usuário autenticado sobrepõe 'companyId'. Migrado do legado IndividualPayment/CourseFinancialDropDown. **(Requer Authorization para autenticação)**
 * @summary Dropdown de planos financeiros ativos e vigentes do curso da matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-registrations/:courseRegistrationId/course-financials}
 */
export function useGetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials<
  TData =
    GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryKey,
>(
  courseRegistrationId: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsPathParams["courseRegistrationId"],
  params?: GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401
          | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryKey(
      courseRegistrationId,
      params,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsQueryOptions(
        courseRegistrationId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials401
      | GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancials500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
